<template>
    <v-card outlined >
      <slot name="header"></slot>
      <div class="postbox">
      <v-card
        width="18%"
        v-for="i in hotsalelist"
        :key="i.id"
        @click="item_click(i.id)"
        class="my-2">
        <v-img
          contain
          width="100%"
          height="150"
          :src="i.thumbnail">
        </v-img>
        <div class="text-center text-button">{{i[$store.state.lang+'_name']}}</div>
        <v-divider class="mx-4"></v-divider>
        <div class="d-flex justify-end align-center">
          <span  v-if="$store.state.lang == 'cn'" class="text-caption">热销度</span>
          <span v-else class="text-caption">HOT</span>
          <v-rating
            :value="4"
            :length="4"
            color="amber"
            dense
            half-increments
            readonly
            size="10">
          </v-rating>
        </div>
      </v-card>
      </div>
    </v-card>
</template>

<script>
export default {
  name:'Hotsalebar',
  data(){
    return{
      hotsalebar_io_api:'hotsalebar/io/',
      hotsalelist:[],
      limit:10,
      productlistid:3,
    }
  },
  methods:{
    item_click(id){
      this.$router.push({
        path:'/productlist',
        query:{
          flag:this.productlistid,
          ischild:'true',
          childid:id,
        },
      });
    },
    fetch(){
      let postdata = {};
      postdata.limit = this.limit;
      this.$axios.post(this.$store.state.baseurl + this.hotsalebar_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.hotsalelist = response.data.data;
              }
            }
          )
          .catch(function (e){})
    },
  },
  mounted(){
    this.fetch();
  },
}
</script>

<style scoped>
.postbox{
  height:100%;
  width:100%;
  display:flex;
  flex-wrap:wrap;
  justify-content:space-around;
}
.divider{
  height:40%;
  width:2px;
  background:#fff;
  margin:0 8px;
}
</style>